import { jsx as _jsx } from "react/jsx-runtime";
import { Conditional } from '../../../common';
import styles from './header-search-bar-suggestions-separator.module.scss';
export const HeaderSearchBarSuggestionsSeparator = ({ displaySeparator }) => (_jsx(Conditional, { test: displaySeparator, children: _jsx("div", { className: `${styles['header-search-bar-suggestions-separator']} d-none d-md-block`, "data-testid": "header-searchbar-suggestion-separator" }) }));
